<template>
  <div class="mobile-page-index">
    <!-- 内容区 -->
    <!-- banner -->
    <div class="mobile-banner-box">
      <!-- 开发 + 设计 创新未来价值 -->
      <div class="mobile-title" id="mobiletitleRef"></div>
      <div class="mobile-title" id="mobiletitleRef2"></div>
      <!-- 帮 助 企 业 快 速 实 现 互 联 网 转 型 -->
      <div class="mobile-mark" id="mobilemarkRef"></div>
      <div class="mobile-mark" id="mobilemarkRef2"></div>
    </div>

    <!-- 业务流程 -->
    <Process />

    <!-- 核心理念 -->
    <Core />

    <!-- 横幅 -->
    <Banner />

    <!-- 合作伙伴 -->
    <Partner />

    <!-- Footer -->
    <Footer />
  </div>
</template>

<script>
import Process from "./components/Process";
import Core from "./components/Core";
import Banner from "./components/Banner";
import Partner from "./components/Partner";
import Footer from "@/components/MobileIframe/components/Footer";
export default {
  name: "home",
  data() {
    return {};
  },
  components: { Process, Core, Banner, Partner, Footer },
  created() {
    setTimeout(() => {
      this.$nextTick(() => {
        new this.Typed("#mobiletitleRef", {
          strings: ["开发 + 设计"],
          typeSpeed: 100,
        });
        new this.Typed("#mobiletitleRef2", {
          strings: ["创新未来价值"],
          typeSpeed: 100,
        });

        new this.Typed("#mobilemarkRef", {
          strings: ["为企业打造高效的数字营销路径， "],
          typeSpeed: 60,
        });
        new this.Typed("#mobilemarkRef2", {
          strings: ["实现可持续增长"],
          typeSpeed: 60,
        });
      });
    }, 1000);
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!-- //TODO 这里为了适配IOS13 所以使用原生css样式 -->
<style >
.mobile-page-index .mobile-banner-box {
  width: 46.875rem;
  height: 69.125rem;
  background: #0d0d0d;
  background: url("~@/assets/mobile/home/moon.png") no-repeat center top;
  background-size: cover;
  padding-top: 32.3125rem;
}

.mobile-page-index .mobile-banner-box .mobile-title {
  text-align: center;
  width: calc(26.8125rem + 1.25rem);
  font-weight: 400;
  font-size: 4.375rem;
  color: #ffcfa0;
  line-height: 5.9375rem;
  margin: 0 auto;
  white-space: nowrap;
}

.mobile-page-index .mobile-banner-box .mobile-mark {
  text-align: center;
  width: calc(24.9375rem + 1.25rem);
  font-weight: 400;
  font-size: 1.75rem;
  color: #ffcfa0;
  line-height: 2.9375rem;
  opacity: 0.5;
  margin: 1.25rem auto 0;
  white-space: nowrap;
}

.mobile-page-index .mobile-banner-box .mobile-mouse-icon {
  width: 1.5rem;
  height: 2.125rem;
  margin: 12.9375rem auto 0;
}

.mobile-page-index .mobile-banner-box .mobile-mouse-icon img {
  width: 100%;
}
</style>
